/** Thrown when {@link requestCliImmediateShutdown} was set (Ctrl+C / bridge close). */
export class CliSqliteInterrupted extends Error {
  override readonly name = 'CliSqliteInterrupted';
  constructor() {
    super('CLI SQLite interrupted (shutdown)');
  }
}

export function isCliSqliteLockError(e: unknown): boolean {
  if (e instanceof CliSqliteInterrupted) return false;
  const msg = e instanceof Error ? e.message : String(e);
  const lower = msg.toLowerCase();
  return (
    lower.includes('database is locked') ||
    lower.includes('sqlite_busy') ||
    lower.includes('sqlite3_busy') ||
    lower.includes('.lock') ||
    lower.includes('eexist') ||
    lower.includes('file exists') ||
    lower.includes('resource busy') ||
    lower.includes('unable to acquire') ||
    lower.includes('could not open') ||
    lower.includes('failed to open') ||
    (lower.includes('database') && lower.includes('locked'))
  );
}
